import { initState } from './index';

export default {
  reset(state) {
    Object.assign(state, initState());
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  addAssets(state, payload) {
    state.list.push(...payload);
  },
  setSummary(state, payload) {
    state.summary = payload;
  },
};
